import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {localDate} from './time';

// A calendar gesture only opens a populated form; publication still requires
// the editor's permission checks, revision freeze and explicit confirmation.
export function useScheduleIntent() {
  const [params, setParams] = useSearchParams();
  const [initialLocal] = useState(() => {
    const day = params.get('plan');
    if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return '';
    const parsed = new Date(day + 'T12:00Z');
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === day && day >= localDate(new Date()) ? day + 'T09:00' : '';
  });
  useEffect(() => {
    if (!params.has('plan')) return;
    setParams(current => {const next = new URLSearchParams(current); next.delete('plan'); return next;}, {replace: true});
  }, [params, setParams]);
  return initialLocal;
}
